(function() {
  const PREFERENCE_COOKIE_NAME = 'user_market_preference';
  const COOKIE_EXPIRY_DAYS = 30;

  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  /**
   * This function listens for a CLICK on a country/language link and saves the preference.
   */
  function savePreferenceOnClick(event) {
    const targetLink = event.target.closest('[data-country-code]');
    
    if (targetLink && targetLink.dataset.countryCode) {
      const countryCode = targetLink.dataset.countryCode;
      console.log('User clicked a new location. Saving preference:', countryCode);
      setCookie(PREFERENCE_COOKIE_NAME, countryCode, COOKIE_EXPIRY_DAYS);
    }
  }

  /**
   * This function runs on page load to check if the user needs to be redirected based on a cookie.
   */
  function enforcePreferenceOnLoad() {
    const savedPreference = getCookie(PREFERENCE_COOKIE_NAME);
    
    if (!savedPreference) {
      return; // No preference saved, so we do nothing.
    }

    const currentPageCountry = window.Shopify.country;

    if (currentPageCountry && savedPreference.toUpperCase() !== currentPageCountry.toUpperCase()) {
      console.log(`Cookie preference ('${savedPreference}') conflicts with current page ('${currentPageCountry}'). Redirecting.`);
      
      const form = document.querySelector('form.shopify-localization-form');
      if (form) {
        const input = form.querySelector('input[name="country_code"]');
        if (input) {
          input.value = savedPreference;
          form.submit();
        }
      }
    }
  }

  // --- Main Execution ---
  document.addEventListener('DOMContentLoaded', function() {
    // Attach our 'save' function to all localization forms, listening for clicks within them.
    document.querySelectorAll('form.shopify-localization-form').forEach(form => {
      form.addEventListener('click', savePreferenceOnClick);
    });

    // Run our 'enforce' function on every page load.
    enforcePreferenceOnLoad();
  });
})();